import { ApiTags, rootApi } from "../../../../services/rootApi";
import { CourseHistoryReq, ICourseHistory } from "./IProgramStructure";


const TAG = ApiTags.AcademicRegistration;

const getTags = (entities: ICourseHistory[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.courseHistoryId })),
  TAG,
];

const courseHistoryApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getProgramStructure: builder.query<ICourseHistory[], void>({
      query: () => "/CourseHistory",
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),

    getCourseHistoryByStudentId: builder.query<ICourseHistory[], { studentId: string }>({
      query: ({ studentId }) => `/CourseHistory/(${studentId})`,
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),

    getCourseHistoryByStudentIdGrade: builder.query<ICourseHistory[], { studentId: string, IsRemedial?: boolean }>({
      query: ({ studentId, IsRemedial }) => `/CourseHistory/(${studentId})/remedial(${IsRemedial})`,
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),

    getCourseHistoryByStudentIdIsSupp: builder.query<ICourseHistory[], { studentId: string, isSupplimentary?: boolean }>({
      query: ({ studentId, isSupplimentary }) => `/CourseHistory/(${studentId})/supplimentary(${isSupplimentary})`,
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),

    createCourseHistory: builder.mutation<ICourseHistory[], Partial<CourseHistoryReq>>({
      query: (payment) => ({
        url: "/CourseHistory/Create",
        method: "POST",
        body: payment
      }),
      invalidatesTags: (result, err, args) => {
        if (err) return [];
        return [{ type: TAG, id: args.id }]
      }
    }),
    DeleteLine: builder.mutation<void, string>({
      query: (lineId) => {
        return {
          url: `/CourseHistory/Delete/${lineId}`,
          method: 'DELETE',
        }
      }
    }),
  }),
});

export const {
  useGetProgramStructureQuery,
  useGetCourseHistoryByStudentIdQuery,
  useGetCourseHistoryByStudentIdGradeQuery,
  useGetCourseHistoryByStudentIdIsSuppQuery,
  useLazyGetCourseHistoryByStudentIdQuery,
  useLazyGetCourseHistoryByStudentIdGradeQuery,
  useLazyGetCourseHistoryByStudentIdIsSuppQuery,
  useCreateCourseHistoryMutation,
  useDeleteLineMutation,
} = courseHistoryApi;
